// versión compatible con React 18+ y 19
import React from 'react';
import ReactDOM from 'react-dom/client'; // Usar el nuevo método
import './index.sass';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Crear el root usando React 18+ API
const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Reportar métricas opcionalmente
reportWebVitals();